export const updateArray = <T>(arr: T[], i: number, value: T) =>
  Object.assign([...arr], {[i]: value})

export const removeFromArray = <T>(arr: T[], indexToRemove: number) =>
  arr.filter((_, i) => i !== indexToRemove)

export const omit = <T extends object>(
  obj: T,
  keyToRemove: string | string[]
) => {
  const keys = typeof keyToRemove === 'string' ? [keyToRemove] : keyToRemove
  return Object.entries(obj).reduce(
    (acc: Record<string, unknown>, [key, val]) => {
      if (!keys.includes(key)) {
        acc[key] = val
      }
      return acc
    },
    {}
  ) as T
}

// pick attributes with keys from obj
export const pick = <T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  keys: K[]
): Pick<T, K> =>
  keys.reduce((acc, k) => {
    // eslint-disable-next-line functional/immutable-data
    acc[k] = obj[k]
    return acc
  }, {} as Pick<T, K>)

export const insertIntoArray = <T>(arr: T[], i: number, value: T) => [
  ...arr.slice(0, i),
  value,
  ...arr.slice(i)
]
